import request from 'utils/request';

const slugs = ['employee.name'];
const listSlugs = ['employees.name'];

export async function query(params) {
  return request({
    url: '/employees/',
    method: 'get',
    data: params,
    slugs: listSlugs,
  });
}

export async function queryOne(params) {
  return request({
    url: `/employees/${params.id}`,
    method: 'get',
    slugs,
  });
}

export async function create(params) {
  return request({
    url: '/employees/',
    method: 'post',
    data: params,
    slugs,
  });
}

export async function update(params) {
  return request({
    url: `/employees/${params.id}`,
    method: 'put',
    data: params,
    slugs,
  });
}

export async function remove(params) {
  return request({
    url: `/employees/${params.id}`,
    method: 'delete',
  });
}

export async function removeMany(params) {
  return request({
    url: '/employees/',
    method: 'delete',
    data: params,
  });
}

export async function clearSalary(params) {
  return request({
    url: '/employees/salary',
    method: 'delete',
    data: params,
  });
}

export async function reportSalary(params) {
  return request({
    url: '/employees/salary',
    method: 'get',
    data: params,
  });
}

export async function exportFile(params) {
  return request({
    url: '/employees/export',
    method: 'post',
    data: params,
    download: 'Nhân viên.xlsx',
    responseType: 'blob', // Download file excel,
  });
}

export async function getTaxNumberRegistrationXml(params) {
  return request({
    url: '/employees/tax-number-registration/xml',
    method: 'get',
    data: params,
  });
}



// WEBPACK FOOTER //
// ./src/services/employee.js